export default "<div>\n  <app-chat-box [currentPartner]=\"currentPartner\" [messagesList]=\"messagesList\" (goBack)=\"close()\"></app-chat-box>\n</div>\n"